import { Team } from '../teams/team.model';
import { TimeOff } from '../timeoff/timeoff.model';
import { PipelineLoanDto } from '../uw-assignment-reshuffle/reshuffle';

export class ReassignmentDto {
    public loan: Reassignment;
    public users: Array<User>;
}

export class Reassignment {
    public loanNumber: string;
    public userId: string;
    public firstName: string;
    public lastName: string;
    public loanOfficer: string;
    public loanProcessor: string;
    public lastCompletedMilestone: string;
    public personaId: string;
    public pipelineLoanData: LoanPipelineData;
    public userLoanAssignment: UserLoanAssignment;
}

export class LoanPipelineData {
    public LoanGuid: string;
    public fields: any;
}

export class User {
    public id: string;
    public name: string;
    public firstName: string;
    public lastName: string;
    public isLead: boolean;
    public isAdmin: boolean;
    public isUnavailable: boolean;
    public persona: string;
    public personaId: string;
    public role: string;
    public roleId: string;
    public email: string;
    public capacity: number | null;
    public encompassUserName: string;
    public teamEmail: string;
    public teams: Team[];
    public teamIds: string[];
    public timeOffDateRanges: TimeOff[];
}

export class ReassignmentResponse {
    public assignedSuccessfully: boolean;
    public messages: string[];
}

export class IgnoredProcessorCloserReassignment {
    public loanNumber: string;
    public personaId: string;
}

export class IgnoredProcessorCloserReassignmentDto {
    public loanNumber: string;
    public personaId: string;
}

export class UserLoanAssignment {
    public Id: string;
    public UserId: string;
    public LoanProgramId: string;
    public PersonaId: string;
    public LoanNumber: string;
    public IsActive: boolean;
    public InactiveUtc: Date;
    public BorrowerSsnHash: string;
    public CoBorrowerSsnHash: string;
}

export class UserLoanAssignmentDto {
    public Id: string;
    public UserId: string;
    public LoanProgramId: string;
    public PersonaId: string;
    public LoanNumber: string;
    public IsActive: boolean;
    public InactiveUtc: Date;
    public BorrowerSsnHash: string;
    public CoBorrowerSsnHash: string;
}

export class ReassignmentBaseDto {
    public PipelineLoanDtos: Array<PipelineLoanDto>;
    public UserLoanAssignmentDtos: Array<UserLoanAssignmentDto>;
    public Users: Array<User>;

}




// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/processor-closer-pipeline-reassignment/reassignment.ts